'use client';
import utilityStyles from '@lichtblick/photon/theme/utilities.module.scss';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import styles from './energy-price-curve.module.css';

export const EnergyPriceCurve = dynamic(
  () => import('./energy-price-curve.client').then((mod) => mod.EnergyPriceCurveClient),
  {
    ssr: false,
    loading: () => <div className={classNames(styles['price-curve-wrapper'], utilityStyles['placeholder-element'])} />,
  },
);
